<template>
  <div class="content">
    <div id="myItemDiv">
      <h2 id="itemH1">My items</h2>
    </div>

    <v-row id="guruPassNFTRow">
      <v-col sm="4" id="itemCol" v-for="item in guruPassNFTs" :key="item.id" @click="clickGuruPassNFT(item.tokenId)">
        <img :src="item.image" alt="Guru Pass NFT" :style="[item.tokenId === selectedGuruPassNFT.tokenId ? {'border': '3px solid red'} : {'border': 'none'} ]" />
        <p id="nameP">{{ item.name }}</p>
      </v-col>
    </v-row>

    <v-pagination id="itemPag" v-model="curPage" :length="pagLen" :total-visible="5" circle @input="onPagination()"></v-pagination>

    <div id="sendNFTDiv" v-if="selectedGuruPassNFT.tokenId !== undefined ">
      <span id="walletAddrSpan">Wallet Address:</span>
      <v-text-field id="toVTF" v-model="toWalletAddress" dense outlined placeholder="Wallet Address" @click="errMsg = '';" background-color="#ededed"></v-text-field>
      <v-btn id="sendBtn" color="primary" large @click="transferGuruPassNFT()" :disabled="toWalletAddress === '' || toWalletAddress.length !== 42 ">Send</v-btn>
    </div>

    <p id="errP" v-if="errMsg != ''">{{ errMsg }}</p>
  </div>
</template>

<script>
  import BigNumber from 'bignumber.js';

  import { sendGetRequest } from '../../utils/axios';

  const guruPassNFTAbi = require("../../constants/abis/guruPassNFT.json");

  export default {
    name: 'MaUserItems',
    props: {
    },
    data: () => ({
      guruPassContract: "",
      curWalletAddress: "",

      // pagination related.
      curPage: 1,
      pagLen: 0,
      perPage: 3,

      ownedNFTCnt: 0,
      guruPassNFTs: [],

      selectedGuruPassNFT: {},
      toWalletAddress: '',

      errMsg: '',

      // WordPress bind data. eros god
      wpData: wpData,
    }),
    mounted() {
      this.initialize();
    },
    methods: {
      async initialize() {
        let _this = this;

        if (typeof window.ethereum === 'undefined') return;

        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.curWalletAddress = accounts[0];

        const web3js = window.web3;
        if (typeof web3js === 'undefined') return;

        this.web3 = new Web3(web3js.currentProvider);

        this.web3.eth.defaultAccount = this.curWalletAddress;

        this.guruPassContract = this.web3.eth.contract(guruPassNFTAbi).at(wpData.GURUPASS_NFT_CONTRACT_ADDRESS);

        this.guruPassContract.balanceOf.call(this.curWalletAddress, function(err, res) {
          if (err) { console.log(err.code); return; }

          _this.ownedNFTCnt = new BigNumber(res).toNumber();

          if (_this.ownedNFTCnt > 0) {
            let forEnd = _this.perPage;
            if (forEnd > _this.ownedNFTCnt) forEnd = _this.ownedNFTCnt;

            for (let i=0; i<forEnd; i++) {
              _this.getGuruPassNFTInfos(i);
            }
          }

          _this.pagLen = (_this.ownedNFTCnt % _this.perPage) > 0 ?  Math.floor(_this.ownedNFTCnt / _this.perPage) + 1 : _this.ownedNFTCnt / _this.perPage;
        });
      },
      getGuruPassNFTInfos(pIndex) {
        let _this = this;

        this.guruPassContract.tokenOfOwnerByIndex.call(this.curWalletAddress, pIndex, function(err, res) {
          if (err) { console.log(err.code); return; }

          let tokenIndex = res;
          _this.guruPassContract.tokenURI.call(tokenIndex, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenURI = res;
            sendGetRequest(tokenURI).then((tokenInfo) => {
              _this.guruPassNFTs.push({id: pIndex+1, tokenId: tokenIndex, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image });
            });
          });
        });
      },
      onPagination() {
        this.guruPassNFTs = [];

        if (this.ownedNFTCnt <= 0) return;

        let startIndex = (this.curPage - 1) * this.perPage;
        let endIndex = (startIndex + this.perPage) < this.ownedNFTCnt ? startIndex + this.perPage : this.ownedNFTCnt;

        let _this = this;

        for (let i=startIndex; i<endIndex; i++) {
          this.guruPassContract.tokenOfOwnerByIndex.call(this.curWalletAddress, i, function(err, res) {
            if (err) { console.log(err.code); return; }

            let tokenId = res;

            _this.guruPassContract.tokenURI.call(tokenId, function(err, res) {
              if (err) { console.log(err.code); return; }

              let tokenURI = res;

              sendGetRequest(tokenURI).then((tokenInfo) => {
                _this.guruPassNFTs.push({id: i+1, tokenId: tokenId, name: tokenInfo.data.name, desc: tokenInfo.data.description, image: tokenInfo.data.image });
              });
            });
          });
        }
      },
      clickGuruPassNFT(pTokenId) {
        this.selectedGuruPassNFT = {};
        this.errMsg = '';

        this.selectedGuruPassNFT.tokenId = pTokenId;
      },
      transferGuruPassNFT() {
        if (this.selectedGuruPassNFT === {}) return;

        let _this = this;
        if (isNaN(this.toWalletAddress)) {
          _this.errMsg = "Please input wallet address correctly.";
          return;
        }
        
        this.guruPassContract.transferFrom(this.curWalletAddress, this.toWalletAddress, this.selectedGuruPassNFT.tokenId, function(err) {
          if (err) {
            _this.errMsg = "Please input wallet address correctly.";
            console.log(err.code);
            return;
          }

          location.reload();
        });
      }
    },
    computed: {
    },
  }
</script>

<style scoped>
  p, h2 {
    margin: 0px;
    font-family: Architects Daughter;
  }

  span {
    font-family: Architects Daughter;
  }

  #myItemDiv {
    background-image: url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
  }
  #myItemDiv #itemH1 {
    padding: 5px 20px;
  }

  #guruPassNFTRow {
    margin-top: 20px;
  }
  #guruPassNFTRow #itemCol img {
    width: 100%;
    box-shadow: 0px 0px 40px -1px rgb(0 0 0 / 43%);
    border-radius: 7px;
  }
  #guruPassNFTRow #itemCol #nameP {
    text-align: center;
    color: #FFFFFF;
    font-weight: 600;
    font-family: Architects Daughter;
    margin-top: 5px;
  }

  #sendNFTDiv {
    display: flex;
    margin-top: 20px;
  }
  #sendNFTDiv #walletAddrSpan {
    margin-right: 5px;
    margin-top: 10px;
    font-weight: bold;
  }
  #sendNFTDiv #sendBtn {
    margin-left: 10px;
    height: 38px;
  }

  #errP {
    text-align: center;
    color: red;
    font-weight: bold;
    margin-top: -20px;
  }

  @media only screen and (max-width: 1300px) {
    #sendNFTDiv #walletAddrSpan {
      margin-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MyAura/MaUserItems.vue